import React from 'react';
import {Col, Row} from "antd";
import {FormattedMessage} from "react-intl";
import '../assets/css/Dentobook.css';

import DetailWrapper from "../components/common/DetailWrapper";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";

const Settings = () => {

    return (
        <AccessControl accessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR]}>
            <DetailWrapper navigateBack={undefined}>
                <Row className="mb-2">
                    <Col span={12}>
                        <h3><FormattedMessage id="settings" /></h3>
                    </Col>
                </Row>
            </DetailWrapper>
        </AccessControl>
    );
};

export default Settings;
